module.exports = __webpack_public_path__ + "img/cp-16.5b93611d.jpg";